import API from "@/api";

export const moduleName = "vdpArticles";

export const actionTypes = {
  ACTION_LOAD_VDP_ARTICLES: "ACTION_LOAD_VDP_ARTICLES",
  ACTION_ADD_VDP_ARTICLE: "ACTION_ADD_VDP_ARTICLE",
  ACTION_EDIT_VDP_ARTICLE: "ACTION_EDIT_VDP_ARTICLE",
  ACTION_DELETE_VDP_ARTICLE: "ACTION_DELETE_VDP_ARTICLE",
  ACTION_UPDATE_VDP_ARTICLE_STATE: "ACTION_UPDATE_VDP_ARTICLE_STATE"
};

export const getterTypes = {
  GETTER_VDP_ARTICLES: "GETTER_VDP_ARTICLES",
  GETTER_VDP_ARTICLES_COUNT: "GETTER_VDP_ARTICLES_COUNT"
};

export const mutationTypes = {
  SET_VDP_ARTICLES_DATA: "SET_VDP_ARTICLES_DATA",
  SET_VDP_ARTICLE: "SET_VDP_ARTICLES",
  UPDATE_VDP_ARTICLE: "UPDATE_VDP_ARTICLE",
  DELETE_VDP_ARTICLE: "DELETE_VDP_ARTICLE"
};

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    vdpArticles: [],
    vdpArticlesCount: 0
  }),

  actions: {
    async [actionTypes.ACTION_LOAD_VDP_ARTICLES]({ commit }, payload) {
      const response = await API.vdpManager.loadVdpArticles(payload);
      const { vdpArticles, count } = response.data;
      commit(mutationTypes.SET_VDP_ARTICLES_DATA, [vdpArticles, count]);
    },
    async [actionTypes.ACTION_UPDATE_VDP_ARTICLE_STATE]({ commit }, payload) {
      const response = await API.vdpManager.updateVdpArticleState(payload);
      return response
    },
    async [actionTypes.ACTION_ADD_VDP_ARTICLE]({ commit }, payload) {
      try{
        const { data: vdpArticle } = await API.vdpManager.addVdpArticle(payload);
        commit(mutationTypes.SET_VDP_ARTICLE, vdpArticle);
        return vdpArticle
      }catch(err){
        const errorDescription = err.response && err.response.data ? err.response.data.description : "Server Error";
        console.log("errorDescription",errorDescription)

        throw errorDescription
      }
 
    },
    async [actionTypes.ACTION_EDIT_VDP_ARTICLE]({ commit }, { blogId, blog }) {
      const { data } = await API.vdpManager.editVdpArticle(blogId, blog);
      commit(mutationTypes.UPDATE_VDP_ARTICLE, data);
    },
    async [actionTypes.ACTION_DELETE_VDP_ARTICLE]({ commit }, { blogId }) {
      await API.vdpManager.deleteVdpArticle(blogId);
      commit(mutationTypes.DELETE_VDP_ARTICLE, blogId);
    }
  },

  mutations: {
    [mutationTypes.SET_VDP_ARTICLES_DATA](state, [vdpArticles, vdpArticlesCount]) {
      if (Array.isArray(vdpArticles)) {
        state.vdpArticles = vdpArticles;
      }
      if (!isNaN(vdpArticlesCount)) {
        state.vdpArticlesCount = vdpArticlesCount;
      }
    },
    [mutationTypes.SET_VDP_ARTICLE](state, vdpArticle) {
      // state.blogs.pop();
      state.vdpArticles.unshift(vdpArticle);
      state.vdpArticlesCount++;
    },
    [mutationTypes.UPDATE_VDP_ARTICLE](state, vdpArticle) {
      const index = state.vdpArticles.findIndex(b => b.id === vdpArticle.id);
      if (index === -1) return;
      state.vdpArticles.splice(index, 1, vdpArticle);
    },
    [mutationTypes.DELETE_VDP_ARTICLE](state, vdpArticleId) {
      const index = state.vdpArticles.findIndex(b => b.id === vdpArticleId);
      if (index === -1) return;
      state.vdpArticles.splice(index, 1);
    }
  },

  getters: {
    [getterTypes.GETTER_VDP_ARTICLES]: state => state.vdpArticles,
    [getterTypes.GETTER_VDP_ARTICLES_COUNT]: state => state.vdpArticlesCount
  }
};
